import Navbar from "components/Navbar"
import React from "react";
import Footer from "components/Footer";
import ProgramList from "components/Program/ProgramList";
import { useSelector } from "react-redux";
import MobileNavbar from "components/MobileNavbar";
import MobileFooter from "components/MobileFooter";

/*

{isMobile ? (
            <>
            <MobileNavbar />
            <Training />
            <Hackathon />
            <Internship />
            <InternationalExchanges />
            <HowToApply />
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <Training />
            <Hackathon />
            <Internship />
            <InternationalExchanges />
            <HowToApply />
            <Footer />
            </>
        )}


*/



function Program () {

    const isMobile = useSelector(state => state.windowSize.isMobile);

    return(
        <>
        {isMobile ? (
            <>
            <MobileNavbar />
            <ProgramList/>
            <MobileFooter />
            </>
        ) : (
            <>
            <Navbar />
            <ProgramList/>
            <Footer />
            </>
        )}
        </>
    )
}

export default Program